<unity-page-container [contentHeader]="$contentHeader()" [contentHeaderSecondary]="$contentHeaderSecondary()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>

  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Assign" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    <unity-dropdown-user-assign-control
      displayName="User"
      description="Select the user to assign to this agreement"
      [selectable]="$selectableUsers()"
      [control]="formGroup.controls.user_id" />
    <ng-content submit-options>
      <unity-action-cancel-shared [disabled]="false" [action]="$returnToAgreementAction()" />
    </ng-content>
  </unity-card-new-shared>
</unity-page-container>
